import angular from 'angular'
import uiRouter from '@uirouter/angularjs'

export default angular.module('backoffice.herramientas', [
  uiRouter
])



// WEBPACK FOOTER //
// ./src/herramientas/module.js